import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { SettingsHeader } from "~/components/layout/settings-header";
import { Button } from "~/components/ui/button";
import { Card, CardContent } from "~/components/ui/card";
import { Input } from "~/components/ui/input";
import { Label } from "~/components/ui/label";
import { Textarea } from "~/components/ui/textarea";
import { api } from "~/lib/api";

export const Route = createFileRoute(
  "/_main/settings/_layout/bookings/booking-widget",
)({
  component: Bookings,
});

function Bookings() {
  const { t } = useTranslation("common");
  const { data } = api.token.getToken.useQuery();

  return (
    <>
      <SettingsHeader title={t("booking_widget")} />
      <div className="flex flex-col gap-4">
        <Card>
          <CardContent>
            <div className="flex flex-col gap-2">
              <Label>token</Label>
              <Input readOnly value={data?.token} />
            </div>
          </CardContent>
        </Card>
        <Card>
          <CardContent className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Label>Script tag</Label>
              <Textarea
                readOnly
                value={`<script id="vrodex-booking-script" data-language="nl" data-token="${data?.token}" defer src="https://bookingwidget.vrodex.app/js/index.js"></script>`}
              />
            </div>
            <Button
              variant="outline"
              onClick={() => {
                window.open(
                  "https://wordpress.org/plugins/vrodex-booking-widget/",
                  "_blank",
                );
              }}
            >
              WordPress Plugin
            </Button>
          </CardContent>
        </Card>
      </div>
    </>
  );
}
